import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    imports: [MatDialogTitle, MatDialogContent, TranslateModule]
})
export class AboutComponent {
    version: string = environment.version;

    constructor(public dialogRef: MatDialogRef<AboutComponent>) {}
}
